//adding service worker
export const registerServiceWorker = () => true
